<template>
  <div class="con">
    <div class="banner">
      <img src="../assets/ycb/abanner.png" alt />
    </div>
    <div class="navList wow fadeInUp" :style="tabStyle">
      <div
        class="item"
        v-for="(item,index) in navList"
        :key="index"
        :class="{active:select===index}"
        @click="change(index)"
      >{{item}}</div>
    </div>
    <div class="main" v-if="select<2">
      <div class="intro" id="gsjs">
        <div class="title wow">
          <p>{{$t('about').text0}}</p>
        </div>
        <div class="content">
          <aboutDia class="aboudDia wow" />
          <div class="threeNums wow" ref="counts">
            <div class="item">
              <div class="one">
                <div class="num">
                  <p id="num1">18</p>
                  <p>
                    <span>{{$t('home').about.three[1]}}</span>
                    <span>+</span>
                  </p>
                </div>
                <div class="img">
                  <img src="../assets/ycb/lsfz.png" alt />
                </div>
              </div>
              <p class="text">{{$t('home').about.three[0]}}</p>
            </div>
            <div class="item">
              <div class="one">
                <div class="num">
                  <p id="num2">1000000</p>
                  <p>
                    <span>{{$t('home').about.three[5]}}</span>
                    <span>+</span>
                  </p>
                </div>
                <div class="img">
                  <img src="../assets/ycb/qxk.png" alt />
                </div>
              </div>

              <p class="text">{{$t('home').about.three[4]}}</p>
            </div>
            <div class="item">
              <div class="one">
                <div class="num">
                  <p id="num3">300000</p>
                  <p>
                    <span>{{$t('home').about.three[5]}}</span>
                    <span>+</span>
                  </p>
                </div>
                <div class="img">
                  <img src="../assets/ycb/ttj.png" alt />
                </div>
              </div>
              <p class="text">{{$t('home').about.three[6]}}</p>
            </div>
          </div>
          <div class="bg">
            <img src="../assets/ycb/abg.png" alt />
          </div>
        </div>
        <div class="threeImg wow fadeInUp">
          <swiper class="swiper" :options="swiperOption2" ref="mySwipers2">
            <swiper-slide class="item" v-for="(item,index) in list" :key="index">
              <img :src="`http://www.znr.com.cn/${item.picurl}`" alt />
            </swiper-slide>
          </swiper>
        </div>
      </div>

      <!--企业文化-->
      <events id="qywh" />
      <div class="ybg">
        <div class="title wow fadeInUp">{{$t('about').spirit[0]}}</div>
        <p class="t1 wow fadeInUp">{{$t('about').spirit[1]}}</p>
        <div class="allItems wow fadeInUp">
          <div class="item">
            <div>
              <i class="iconfont icon-bazi"></i>
            </div>
            <p class="text1">{{$t('about').spirit[2]}}</p>
            <p class="text2">{{$t('about').spirit[3]}}</p>
          </div>
          <div class="item">
            <div>
              <i class="iconfont icon-feiji"></i>
            </div>
            <p class="text1">{{$t('about').spirit[4]}}</p>
            <p class="text2">{{$t('about').spirit[5]}}</p>
          </div>
          <div class="item">
            <div>
              <i class="iconfont icon-zuanshi"></i>
            </div>
            <p class="text1">{{$t('about').spirit[6]}}</p>
            <p class="text2">{{$t('about').spirit[7]}}</p>
          </div>
          <div class="item">
            <div>
              <i class="iconfont icon-hexinjiazhi"></i>
            </div>
            <p class="text1">{{$t('about').spirit[8]}}</p>
            <p class="text2">{{$t('about').spirit[9]}}</p>
          </div>
        </div>
      </div>
      <!--发展历程-->
      <history id="fzlc" />

      <!--        视频-->
      <div class="yx wow fadeInUp">
        <img src="../assets/ycb/video2.png" alt />
        <span>
          <i class="iconfont icon-bianzu"></i>
        </span>
      </div>

      <!--        <honor />-->
    </div>

    <div class="fz" v-if="select===2">
      <div class="title wow fadeInUp">发展历程</div>
      <p class="t1 wow fadeInUp">每一次变革都属于我们努力的成果</p>
      <div class="allItems">
        <div class="item wow" v-for="(item,index) in hList" :key="index">
          <div class="left">
            <p>{{item.title}}</p>
          </div>
          <div class="right">
            <p>{{item.title}}</p>
            <div class="img">
              <img :src="`http://www.znr.com.cn/${item.picurl}`" alt />
            </div>
          </div>
        </div>
      </div>
      <div class="btn wow fadeInUp" @click="load">
        <span>继续浏览</span>
        <i class="iconfont icon-shuaxin"></i>
      </div>
    </div>

    <div class="ori" v-if="select===3" id="zzjg">
      <div class="title wow fadeInUp">组织架构</div>
      <div class="img">
        <img src="../assets/ycb/ori.png" alt />
      </div>
    </div>

    <div class="team" v-if="select===4" id="ldtd">
      <div class="title wow fadeInUp">领导团队</div>
      <div class="allItems">
        <div class="item wow fadeInUp" v-for="(item,index) in tList" :key="index">
          <div class="one">
            <img :src="`http://www.znr.com.cn/${item.picurl}`" alt />
          </div>
          <div class="two">
            <p>{{item.title}}</p>
            <p>{{item.description}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="hope" v-if="select===5" id="zlyj">
      <div class="title wow fadeInUp">{{$t('about').strategic[0]}}</div>
      <p class="t1 wow fadeInUp">{{$t('about').strategic[1]}}</p>
      <p
        class="t2 wow fadeInUp"
      >{{$t('about').strategic[2]}}</p>
      <div class="yj">
        <img src="../assets/ycb/yj.png" alt />
      </div>
      <!-- <div class="ybg">
        <div class="title wow fadeInUp">企业精神</div>
        <p class="t1 wow fadeInUp">艰苦创业、实事求是；敢为人先，追求卓越</p>
        <div class="allItems wow fadeInUp">
          <div class="item">
            <div>
              <i class="iconfont icon-bazi"></i>
            </div>
            <p class="text1">经营理念</p>
            <p class="text2">诚信双赢，人本和谐</p>
          </div>
          <div class="item">
            <div>
              <i class="iconfont icon-feiji"></i>
            </div>
            <p class="text1">市场理念</p>
            <p class="text2">主动赢得先机，观念创造价值</p>
          </div>
          <div class="item">
            <div>
              <i class="iconfont icon-zuanshi"></i>
            </div>
            <p class="text1">发展理念</p>
            <p class="text2">创新无终点 进取无止境</p>
          </div>
          <div class="item">
            <div>
              <i class="iconfont icon-hexinjiazhi"></i>
            </div>
            <p class="text1">人才理念</p>
            <p class="text2">唯贤是举，不拘一格，精英治理,育人晋人。</p>
          </div>
        </div>
      </div> -->
    </div>

    <transition name="fade">
      <honor v-if="select===6" />
    </transition>

    <foot-Component class="foot wow fadeIn"></foot-Component>
  </div>
</template>

<script>
import { CountUp } from "countup.js";
import footComponent from "../components/foot";
import { getProductsUrl, PageModel } from "../util/lang";
import aboutDia from "../components/aboutDia";
import history from "../components/history";
import honor from "../components/honor";
import events from "../components/events";
import Scrollbar from "smooth-scrollbar";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "about",
  data() {
    return {
      tabStyle: "",
      swiperOption2: {
        notNextTick: true,
        slidesPerView: 3, //一行显示3个
        speed: 1000,
        // initialSlide :1,
        // centeredSlides : true,
        slideToClickedSlide: true,
        init: false,
        loop: true,
        spaceBetween: 20,
        setWrapperSize: true,
        autoplay: true
      },
      list: [],
      tList: [],
      hList: [],
      totalPage: "",
      id: "",
      src: "",
      showImg: false,
      dStyle: {},
      navList: [
        "公司简介",
        "企业文化",
        "发展历程",
        "组织架构",
        "领导团队",
        "战略愿景",
        "企业荣誉"
      ],
      select: 0,
      aStyle: ""
    };
  },
  filters: {
    formatDate: function(value) {
      value = parseInt(value) * 1000;
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      // let h = date.getHours();
      // h = h < 10 ? ('0' + h) : h;
      // let m = date.getMinutes();
      // m = m < 10 ? ('0' + m) : m;
      // let s = date.getSeconds();
      // s = s < 10 ? ('0' + s) : s;
      return y + "-" + MM + "-" + d + " ";
    }
  },
  components: {
    footComponent,
    history,
    events,
    honor,
    aboutDia,
    swiper,
    swiperSlide
  },
  mounted() {
    //   let threeNums=document.getElementById("threeNums")
    Scrollbar.initAll(document.getElementById("scroller-wrapper"));
    this.scrollbar = Scrollbar.get(document.getElementById("scroller-wrapper"));
    this.scrollbar.scrollTo(0, 1);
    this.scrollbar.addListener(status => {
      this.tabStyle = { top: status.offset.y + 90 + "px" };
      window.pageYOffset = this.scrollbar.scrollTop;
    });
    setTimeout(() => {
      if (window.location.search.replace("?", "").split("=")[1] !== undefined) {
        setTimeout(() => {
          this.setIndex(parseInt(this.getNid()));
        }, 1000);
      } else {
        setTimeout(() => {
          this.setIndex(0);
        }, 1000);
      }
      this.count();
      if (this.$i18n.locale === "en") {
        this.getList("102");
        this.getHistory("103");
        this.getTeam("104");
      } else {
        this.getList("2");
        this.getHistory("3");
        this.getTeam("4");
      }
    }, 100);
  },
  methods: {
    getList(id) {
      const url = `${getProductsUrl(id)}`;
      this.$axios.get(url).then(res => {
        this.list = res.data.data;
        setTimeout(() => {
          this.$refs.mySwipers2.swiper.init();
        }, 100);
      });
    },
    load() {
      if (this.page <= this.totalPage) {
        this.$nextTick(() => {
          const url = `${PageModel("PageModel", this.page++, 2, this.id)}`;
          this.$axios.get(url).then(res => {
            this.hList = this.hList.concat(res.data.data);
            // console.log(res.data)
          });
        });
      } else {
        this.$notify({
          title: "Prompt",
          message: "Already Loaded",
          offset: 100
        });
      }
    },
    getHistory(id) {
      this.id = id;
      this.page = 2;
      const url = `${PageModel("PageModel", 1, 2, id)}`;
      this.$axios.get(url).then(res => {
        this.hList = res.data.data;
        this.totalPage = res.data.totalPage;
      });
    },
    getTeam(id) {
      const url = `${getProductsUrl(id)}`;
      this.$axios.get(url).then(res => {
        this.tList = res.data.data;
      });
    },
    getNid() {
      return window.location.search
        .replace("?", "")
        .split("=")[1]
        .split("?")[0];
    },
    menushow(HeaderMShow, n) {
      this.showImg = HeaderMShow;
      this.src = n;
    },
    hide() {
      this.showImg = false;
    },
    count() {
      let element = this.$refs.counts;
      let actualTop = element.offsetTop;
      //   let current = element.offsetParent;
      while (element == element.offsetParent) {
        actualTop += element.offsetTop;
        /* current = current.offsetParent; */
      }
      let demoFi1 = new CountUp("num1", 18);
      let demoFi2 = new CountUp("num2", 1000000);
      let demoFi3 = new CountUp("num3", 300000);
      //   demoFi1.start();
      //   demoFi2.start();
      //   demoFi3.start();
      let numok = false;
      let scrollbar = Scrollbar.get(
        document.getElementById("scroller-wrapper")
      );
      if (scrollbar) {
        scrollbar.addListener(status => {
          if (!numok) {
            if (actualTop < status.offset.y + document.body.clientHeight) {
              demoFi1.start();
              demoFi2.start();
              demoFi3.start();
              numok = true;
            }
          }
        });
      }
    },
    setIndex(n) {
      this.select = n;
      if (n === 0) {
        Scrollbar.get(
          document.getElementById("scroller-wrapper")
        ).scrollIntoView(document.querySelector("#gsjs"), {
          offsetTop: 125
        });
      } else if (n === 1) {
        Scrollbar.get(
          document.getElementById("scroller-wrapper")
        ).scrollIntoView(document.querySelector("#qywh"), {
          offsetTop: 125
        });
      } else if (n === 3) {
        setTimeout(() => {
          Scrollbar.get(
            document.getElementById("scroller-wrapper")
          ).scrollIntoView(document.querySelector("#zzjg"), {
            offsetTop: 125
          });
        }, 100);
      } else if (n === 4) {
        setTimeout(() => {
          Scrollbar.get(
            document.getElementById("scroller-wrapper")
          ).scrollIntoView(document.querySelector("#ldtd"), {
            offsetTop: 125
          });
        }, 100);
      } else if (n === 5) {
        setTimeout(() => {
          Scrollbar.get(
            document.getElementById("scroller-wrapper")
          ).scrollIntoView(document.querySelector("#zlyj"), {
            offsetTop: 125
          });
        }, 100);
      }
    },
    change(n) {
      const link = `/about.html?index=${n}`;
      window.open(link, "_self");
    }
  }
};
</script>

<style lang="scss" scoped>
.con {
  width: 100%;
  animation: run5 1s linear forwards;
  position: relative;
  overflow: hidden;
  @keyframes run5 {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .banner {
    width: 100%;
    position: relative;
    overflow: hidden;
    height: 100vh;
    img {
      display: block;
      width: 100%;
      object-fit: cover;
      animation: sbig 5s linear forwards;
    }
    @keyframes sbig {
      from {
        transform: scale(1);
        filter: blur(5px);
      }
      to {
        transform: scale(1.05);
        filter: blur(0);
      }
    }
  }
  .navList {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    z-index: 100000;
    background-color: rgba(255, 255, 255, 0.3);
    position: absolute;
    top: 95px;
    left: 0;
    display: none;
    .item {
      width: 11%;
      cursor: pointer;
      padding: 20px 0;
      text-align: center;
      font-family: "SourceHanSerifCN-Regular";
      transition: all 600ms;
      position: relative;
      /*&::before{*/
      /*    content: "";*/
      /*    width: 100%;*/
      /*    height: 3px;*/
      /*    background-color:#6D2D79;*/
      /*    position: absolute;*/
      /*    left: 0;*/
      /*    top: 0;*/
      /*    transform-origin: 100%;*/
      /*    -webkit-transform-origin: 100%;*/
      /*    -webkit-transition: -webkit-transform .4s cubic-bezier(.4,0,.2,1);*/
      /*    transition: transform .4s cubic-bezier(.4,0,.2,1);*/
      /*    -webkit-transform: scaleX(0);*/
      /*    visibility: hidden\9;*/
      /*}*/
      &:hover {
        color: #6d2d79;
      }
      /*&:hover::before{*/
      /*    transform: scaleX(1);*/
      /*    -webkit-transform: scaleX(1);*/
      /*    -moz-transform: scaleX(1);*/
      /*    transform-origin: 0;*/
      /*    -webkit-transform-origin: 0;*/
      /*    visibility: visible\9;*/
      /*}*/
    }
    .item:nth-child(3) {
      display: none;
    }
    .item:nth-child(7) {
      display: none;
    }
    .active {
      color: #6d2d79;
      &::before {
        transform: scaleX(1);
        -webkit-transform: scaleX(1);
        -moz-transform: scaleX(1);
        transform-origin: 0;
        -webkit-transform-origin: 0;
        visibility: visible\9;
      }
    }
  }
  .main {
    width: 100%;
    .intro {
      width: 1440px;
      margin: 80px auto;
      animation-duration: 3s;
      .title {
        width: 100%;
        animation: 1s fadeInLeft linear forwards;
        p:nth-child(1) {
          font-family: "SOURCEHANSANSCN-BOLD";
          font-size: 30px;
          padding: 10px 0;
          position: relative;
          &::before {
            width: 24px;
            height: 2px;
            background: rgba(109, 45, 121, 1);
            content: "";
            display: inline-block;
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }
      }
      .content {
        width: 100%;
        margin: 60px auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        position: relative;
        align-items: center;
        .aboudDia {
          animation: 1s fadeInLeft linear forwards;
        }
        .threeNums {
          width: 30%;
          animation: 1s fadeInRight linear forwards;
          .item {
            width: 100%;
            border-bottom: 1px solid rgba(0, 0, 0, 0.2);
            padding: 20px 0;
            margin-top: 10px;
            .one {
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              .num {
                display: flex;
                flex-direction: row;
                p:nth-child(1) {
                  color: #6d2d79;
                  font-size: 60px;
                  font-family: "DINEngschriftStd";
                }
                p:nth-child(2) {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  font-family: "SourceHanSansSC-Regular";
                  margin-left: 5px;
                  span:nth-child(2) {
                    font-size: 25px;
                  }
                }
              }
              .img {
                margin-right: 30px;
              }
            }
            .text {
              font-family: "SourceHanSansSC-Regular";
              margin: 10px auto;
            }
          }
        }
        .bg {
          position: absolute;
          width: 100%;
          left: 0;
          top: 0;
          text-align: center;
          z-index: -1;
        }
      }
      .threeImg {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .swiper {
          width: 100%;
          .item {
            width: 30%;
            overflow: hidden;
            cursor: pointer;
            img {
              width: 100%;
              display: block;
              object-fit: cover;
              transition: all 600ms;
            }
            &:hover {
              img {
                transform: scale(1.05);
              }
            }
          }
        }
      }
    }
    .ybg {
      width: 100%;
      background: url("../assets/ycb/pbg.png");
      padding: 200px 0;
      background-size: cover;
      padding-top: 100px;
      .title {
          display: flex;
          flex-direction: column;
        color: white;
        font-size: 30px;
        font-weight: bold;
        text-align: center;
        &::after {
          content: "";
          width: 24px;
          height: 2px;
          background: #6d2d79;
          display: inline-block;
          margin: 20px auto;
        }
      }
      .t1 {
        color: white;
        font-size: 35px;
        text-align: center;
        &::after {
          display: none;
        }
      }
      .allItems {
        width: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 80px;
        .item {
          width: 25%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          cursor: pointer;
          div {
            i {
              color: white;
              font-size: 50px;
              transition: all 600ms;
              display: inline-block;
            }
          }
          .text1 {
            color: white;
            font-family: "SourceHanSansSC-Medium";
            font-size: 25px;
            margin-top: 15px;
            transition: all 600ms;
          }
          .text2 {
            color: white;
            font-size: 14px;
            font-family: "SOURCEHANSANSCN-LIGHT";
            line-height: 30px;
            height: 90px;
            margin-top: 15px;
          }
          &:hover {
            div {
              i {
                color: #6d2d79;
                transform: rotateY(360deg);
              }
            }
            .text1 {
              color: #6d2d79;
            }
          }
        }
      }
    }
    .yx {
      width: 100%;
      background-color: white;
      padding: 60px 0;
      position: relative;
      img {
        width: 1440px;
        margin: 0 auto;
        display: block;
      }
      span {
        position: absolute;
        left: 49%;
        top: 42%;
        cursor: pointer;
        i {
          color: white;
          font-size: 50px;
          transition: all 600ms;
        }
        &:hover {
          i {
            color: #6d2d79;
          }
        }
      }
    }
  }
  .fz {
    width: 1440px;
    margin: 60px auto;
    .title {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-family: "SOURCEHANSANSCN-BOLD";
      font-size: 30px;
      &::after {
        content: "";
        width: 24px;
        height: 2px;
        background: rgba(109, 45, 121, 1);
        display: inline-block;
        margin: 20px auto;
      }
    }
    .t1 {
      font-family: "SOURCEHANSANSCN-LIGHT";
      text-align: center;
    }
    .allItems {
      width: 80%;
      margin: 30px auto;
      .item {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        animation-delay: 500ms;
        animation: 2s fadeInRight linear forwards;
        .left {
          width: 50%;
          position: relative;
          border-right: 1px solid rgba(0, 0, 0, 0.1);
          p {
            font-size: 35px;
            font-family: "it";
            text-align: right;
            width: 90%;
            margin: 0 auto;
          }
          &::after {
            content: "";
            display: inline-block;
            width: 14px;
            height: 14px;
            background: rgba(109, 45, 121, 1);
            border-radius: 50%;
            position: absolute;
            right: -7px;
            top: 0;
          }
        }
        .right {
          width: 50%;
          padding: 60px 0;
          position: relative;
          p {
            font-size: 18px;
            font-family: "SourceHanSansSC-Normal";
            width: 80%;
            margin: 0 auto;
          }
          .img {
            width: 80%;
            position: relative;
            box-shadow: 10px 50px 0 0 #6d2d79;
            height: 246px;
            margin: 30px auto;
            cursor: pointer;
            img {
              width: 100%;
              display: block;
              object-fit: cover;
              transition: all 600ms;
              z-index: 1000;
            }
            &:hover {
              img {
                transform: scale(1.05);
              }
            }
          }
          &::before {
            content: "";
            display: inline-block;
            width: 12px;
            height: 100px;
            background: rgba(109, 45, 121, 1);
            position: absolute;
            left: 0;
            top: 60px;
          }
        }
      }
      .item:nth-of-type(even) {
        flex-direction: row-reverse;
        animation: 2s fadeInLeft linear forwards;
        .left {
          border-left: 1px solid rgba(0, 0, 0, 0.1);
          border-right: none;
          p {
            text-align: left;
          }
          &::after {
            content: "";
            display: inline-block;
            width: 14px;
            height: 14px;
            background: rgba(109, 45, 121, 1);
            border-radius: 50%;
            position: absolute;
            left: -7px;
            right: auto;
            top: 0;
          }
        }
        .right {
          &::before {
            content: "";
            display: inline-block;
            width: 12px;
            height: 100px;
            background: rgba(109, 45, 121, 1);
            position: absolute;
            right: 0;
            left: auto;
            top: 60px;
          }
        }
      }
    }
    .btn {
      width: 153px;
      height: 36px;
      background: rgba(109, 45, 121, 1);
      box-shadow: 0px 0px 22px 0px rgba(40, 11, 45, 0);
      border-radius: 18px;
      text-align: center;
      line-height: 36px;
      margin: 60px auto;
      color: white;
      font-size: 14px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      cursor: pointer;
      transition: all 600ms;
      i {
        margin-left: 10px;
        transition: all 600ms;
      }
      &:hover {
        box-shadow: 0px 0px 22px 0px rgba(40, 11, 45, 0.48);
      }
    }
  }
  .ori {
    width: 1440px;
    margin: 60px auto;
    .title {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-family: "SOURCEHANSANSCN-BOLD";
      font-size: 30px;
      &::after {
        content: "";
        width: 24px;
        height: 2px;
        background: rgba(109, 45, 121, 1);
        display: inline-block;
        margin: 20px auto;
      }
    }
    .img {
      width: 100%;
      overflow: hidden;
      margin: 60px auto;
      text-align: center;
      img {
        max-width: 100%;
        object-fit: contain;
      }
    }
  }
  .team {
    width: 1440px;
    margin: 60px auto;
    .title {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-family: "SOURCEHANSANSCN-BOLD";
      font-size: 30px;
      &::after {
        content: "";
        width: 24px;
        height: 2px;
        background: rgba(109, 45, 121, 1);
        display: inline-block;
        margin: 20px auto;
      }
    }
    .allItems {
      width: 100%;
      margin: 60px auto;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .item {
        width: 29%;
        margin-left: 3%;
        margin-top: 40px;
        cursor: pointer;
        .one {
          width: 100%;
          overflow: hidden;
          img {
            width: 100%;
            display: block;
            object-fit: cover;
            transition: all 600ms;
          }
        }
        .two {
          width: 90%;
          margin: 15px auto;
          text-align: center;
          p:nth-child(1) {
            font-size: 20px;
            color: #1c1c1c;
            font-family: "SourceHanSansSC-Normal";
            transition: all 600ms;
          }
          p:nth-child(2) {
            font-family: "SOURCEHANSANSCN-LIGHT";
            color: #1c1c1c;
            margin-top: 10px;
          }
        }
        &:hover {
          .one {
            img {
              transform: scale(1.05);
            }
          }
          .two {
            p:nth-child(1) {
              color: #6d2d79;
            }
          }
        }
      }
    }
  }
  .hope {
    width: 100%;
    background-color: #f6f6f6;
    margin: 0 auto;
    padding: 60px 0;
    .title {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-family: "SOURCEHANSANSCN-BOLD";
      font-size: 30px;
      &::after {
        content: "";
        width: 24px;
        height: 2px;
        background: rgba(109, 45, 121, 1);
        display: inline-block;
        margin: 20px auto;
      }
    }
    .t1 {
        text-align: center;
      font-family: "SourceHanSansSC-Normal";
      font-size: 35px;
      margin: 20px auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #6d2d79;
      width: 60%;
      margin: 0 auto;
      &::after {
        content: "";
        display: inline-block;
        height: 1px;
        width: 440px;
        background-color: rgba(0, 0, 0, 0.2);
        margin-top: 10px;
      }
    }
    .t2 {
      font-family: "SOURCEHANSANSCN-LIGHT";
      font-size: 18px;
      text-align: center;
      width: 50%;
      margin: 30px auto;
      line-height: 40px;
    }
    .yj {
      text-align: center;
      margin-top: 40px;
    }
    .ybg {
      width: 100%;
      background: url("../assets/ycb/pbg.png");
      padding: 200px 0;
      background-size: cover;
      padding-top: 100px;
      .title {
        color: white;
      }
      .t1 {
        color: white;
        &::after {
          display: none;
        }
      }
      .allItems {
        width: 1440px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 80px;
        .item {
          width: 25%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          cursor: pointer;
          div {
            i {
              color: white;
              font-size: 50px;
              transition: all 600ms;
              display: inline-block;
            }
          }
          .text1 {
            color: white;
            font-family: "SourceHanSansSC-Medium";
            font-size: 25px;
            margin-top: 15px;
            transition: all 600ms;
          }
          .text2 {
            color: white;
            font-size: 14px;
            font-family: "SOURCEHANSANSCN-LIGHT";
            line-height: 30px;
            height: 90px;
            margin-top: 15px;
          }
          &:hover {
            div {
              i {
                color: #6d2d79;
                transform: rotateY(360deg);
              }
            }
            .text1 {
              color: #6d2d79;
            }
          }
        }
      }
    }
  }
  @keyframes fadeInLeft {
    0% {
      opacity: 0;
      -webkit-transform: translateX(-20px);
      -ms-transform: translateX(-20px);
      transform: translateX(-20px);
    }
    100% {
      opacity: 1;
      -webkit-transform: translateX(0);
      -ms-transform: translateX(0);
      transform: translateX(0);
    }
  }
  @keyframes fadeInRight {
    0% {
      opacity: 0;
      transform: translateX(20px);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }
  .foot {
    animation-duration: 2s;
  }
  @keyframes transition1 {
    0% {
      transform: translate(-300px, -300px);
      opacity: 0;
    }
    100% {
      transform: translate(0, 0);
      opacity: 1;
    }
  }
  @keyframes transition2 {
    0% {
      transform: translate(300px, -300px);
      opacity: 0;
    }
    100% {
      transform: translate(0, 0);
      opacity: 1;
    }
  }
  @keyframes polygon {
    0% {
      clip-path: polygon(0 0, 0 100%, 0 100%, 0 0);
    }
    100% {
      clip-path: polygon(0 0, 0 100%, 100% 100%, 100% 0);
    }
  }
  @media screen and (max-width: 1440px) {
    .main {
      .intro {
        width: 90%;
      }

      .yx {
        width: 90%;
        margin: 0 auto;
        img {
          width: 100%;
        }
      }
    }
    .ori {
      width: 90%;
    }
    .hope {
      .t1 {
        font-size: 20px;
      }
      .ybg {
        .allItems {
          width: 90%;
        }
      }
    }
    .big2 {
      img {
        height: 500px;
        object-fit: contain;
      }
    }
  }
  @media screen and (max-width: 1000px) {
    .banner {
      img {
        height: 100%;
        object-fit: cover;
      }
    }
    .main {
      .intro {
        margin: 30px auto;
        .title {
          p:nth-child(1) {
            font-size: 20px;
          }
        }
        .content {
          margin: 30px auto;
          flex-direction: column;
          .threeNums {
            width: 100%;
            .item {
              .one {
                .num {
                  p:nth-child(1) {
                    font-size: 40px;
                  }
                }
              }
            }
          }
        }
      }
      .ybg{
          padding: 100px 0;
          .t1{
              font-size: 16px;
              width: 90%;
              margin: 0 auto;
          }
          .allItems{
              width: 100%;
              flex-wrap: wrap;
              justify-content: space-around;
              .item{
                  width: 48%;
                  margin-bottom: 20px;
                  i{
                      font-size: 35px !important;
                  }
                  .text1{
                      font-size: 16px;
                  }
              }
          }
      }
      .yx {
        span {
          i {
            font-size: 25px;
          }
        }
      }
    }
  }
}
</style>
